import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fs-6 fw-bold" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = { class: "d-flex align-items-center gap-5 justify-content-between w-125px" }

import { ref, onMounted } from "vue";
import {
  SiteTypesValues,
  ConfigSiteTypesSelections,
} from "@/core/types/SiteTypes";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoCreatePermission',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>(ConfigSiteTypesSelections.value);
const mainSwitch = ref<any>(ConfigSiteTypesSelections.value[0]);
const criteria = ref<any>({
  category: "public",
  rowIds: SiteTypesValues.value,
  keys: ["AutoCreateTradeAccountEnabled"],
});

const fecthData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryConfigs(criteria.value);
    data.value.map((item) => {
      const match = res.data.find((x) => x.rowId === item.value);
      const defaultData = res.data.find((data) => data.rowId === 0);

      if (match) {
        item.data = match;
        item.switchValue = match.value["value"];
        item.isDefault = false;
      } else if (defaultData) {
        item.data = defaultData;
        item.switchValue = false;
        item.isDefault = true;
      }
    });
    mainSwitch.value = data.value.find((x) => x.value === 0);
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const onChange = async (item: any) => {
  isLoading.value = true;
  try {
    item.data.value["value"] = item.switchValue;
    const submitData = {
      value: item.data.value,
      key: item.data.key,
      name: item.data.name,
      description: item.data.description,
      dataFormat: item.data.dataFormat,
    };
    await SystemService.updateConfigByKey(
      "public",
      item.value,
      "AutoCreateTradeAccountEnabled",
      submitData
    );
    await fecthData();
  } catch (e) {
    console.log(e);
  }

  isLoading.value = false;
};

onMounted(async () => {
  await fecthData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("title.autoCreateAccountPermission")), 1)
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (item.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("fields.mainSwitch")), 1)
              ]))
            : _createCommentVNode("", true),
          (item.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("fields.siteSwitch")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (item.value === 0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  effect: "plain",
                  type: "success",
                  class: "w-50px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  effect: "plain",
                  type: "warning",
                  class: "w-50px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1024)),
            _createVNode(_component_el_switch, {
              style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
              modelValue: item.switchValue,
              "onUpdate:modelValue": ($event: any) => ((item.switchValue) = $event),
              "inline-prompt": "",
              "active-text": "ON",
              "inactive-text": "OFF",
              "active-value": true,
              "inactive-value": false,
              size: "large",
              onChange: ($event: any) => (onChange(item)),
              disabled: mainSwitch.value.switchValue === false && item.value !== 0
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
          ]),
          (item.value == 0)
            ? (_openBlock(), _createBlock(_component_el_divider, { key: 2 }))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])), [
      [_directive_loading, isLoading.value]
    ])
  ]))
}
}

})